import { ReactNode } from 'react';

import { tokens } from '../theme/tokens';
import { FlexGap } from './FlexGap';
import { Separator } from './Separator';
import { Heading3, Paragraph } from './Text';

type Props = {
	title?: ReactNode;
	description?: ReactNode;
	actions?: ReactNode;
	/** First block under the page title — no top separator. */
	first?: boolean;
	children?: ReactNode;
};

export function SettingsSection({ title, description, actions, first, children }: Props) {
	const heading =
		title == null ? null : typeof title === 'string' || typeof title === 'number' ? (
			<Heading3 mb={0}>{title}</Heading3>
		) : (
			title
		);

	const copy =
		description == null ? null : typeof description === 'string' ? (
			<Paragraph mb={0}>{description}</Paragraph>
		) : (
			description
		);

	return (
		<FlexGap flexDirection="column" gap={tokens.gap.section} width="100%">
			{!first && <Separator />}
			<FlexGap flexDirection="column" gap={tokens.gap.group} width="100%">
				{(heading || actions) && (
					<FlexGap
						alignItems="center"
						justifyContent="space-between"
						gap={tokens.gap.group}
						width="100%"
					>
						{heading}
						{actions}
					</FlexGap>
				)}
				{copy}
				{children}
			</FlexGap>
		</FlexGap>
	);
}
